// src/components/Relaciones.js
import React, { useState, useEffect } from 'react';
import { Typography, Divider, Table, Button, Spin, message, Popconfirm, Form, Input, Select, Dropdown, Space } from 'antd';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import HeaderComponent from "./../modules/Shared/components/HeaderComponent";
import ModalVisualizacionArchivos from "./../modules/Relaciones/modals/ModalVisualizacionArchivos";
import { ArrowLeftOutlined, EditOutlined, SmileOutlined, DownOutlined, SafetyCertificateOutlined, CheckCircleTwoTone, WarningTwoTone } from '@ant-design/icons';
import axios from "./../services/http";
import DropdownActionsTable from '../modules/Relaciones/components/DropdownActionsTable';
import EdicionMontosCmp from "./../modules/Relaciones/components/EdicionMontosCmp";

function Relaciones() {

  const location = useLocation();
  const { from } = location.state;
  const [relaciones, setRelaciones] = useState([]);
  const [relacionesCat, setRelacionesCat] = useState([]);
  const [firstFriday, setFirstFriday] = useState();
  const [nextDays, setnextDays] = useState();
  const [construction, setConstruction] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  let next = new Date();
  const [messageApi, contextHolder] = message.useMessage();
  const [catTypes, setCatTypes] = useState([
    { value: 'Material', label: "Material" },
    { value: 'Mano de obra', label: "Mano de obra" },
    { value: 'Subcontrato', label: "Subcontrato" },
    { value: 'Herramienta', label: "Herramienta" },
    { value: 'Equipo', label: "Equipo" },
    { value: 'Indirecto', label: "Indirecto" }
  ]);
  const numberFormat = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 });

  // <Button type="default" disabled={editingKey !== ''} onClick={() => edit(record)}>
  //                   <EditOutlined />
  //                 </Button>
  //                 <Typography.Link style={{"marginLeft":"5px"}} onClick={() => openDialogFilesWithParams(record)}>
  //                   Ver Archivos
  //                 </Typography.Link>
  const items = [
    {
      key: '1',
      label: (
        <a rel="noopener noreferrer">
          Ver archivos
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a rel="noopener noreferrer">
          Editar relación
        </a>
      ),
      icon: <EditOutlined />
    },
    {
      key: '3',
      label: (
        <a target="_blank" rel="noopener noreferrer">
          Autorizar
        </a>
      ),
      disabled: true,
      icon: <SafetyCertificateOutlined />
    }
  ];

  const [openDialogFiles, setDialogFiles] = useState(false);
  const [relationshipViewer, setRelationshipViewer] = useState({});

  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      tipo_de_pago: (record.tipo_de_pago !== null && record.tipo_de_pago !== undefined ? record.tipo_de_pago : null),
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey('');
  };

  useEffect(() => {
    fetchRelaciones();
    fetchRelacion();
    GetConstruction();
    //console.log("from.fecha_creacion***", from.fecha_creacion)
    let currentYear = new Date(from.fecha_creacion).getFullYear();
    let weekNumber = getWeekNumber(from.fecha_creacion);
    //console.log("obra week***", weekNumber)
    let daysOfWeek = getWeekDates(currentYear, weekNumber);
    setFirstFriday(daysOfWeek);
    setnextDays(daysOfWeek);
    //console.log("daysOfWeek week***", daysOfWeek)
  }, []);

  const fetchRelacion = async () => {
    try {
      const response = await axios.HTTP_GET(`/api/relacion-semanal/${from.id}`);
      let relaciones = [];
      for (let i = 1; i <= response.numeroRelacion; i++) relaciones.push({ value: i });
      setRelacionesCat(relaciones);
      //setCatRelaciones(relaciones);
    } catch (error) {
      console.error('Error al obtener la relación:', error);
    }
  };

  const GetConstruction = async () => {
    try {
      const response = await axios.HTTP_GET(`/api/construction/${from.id}`);
      setConstruction(response?.[0]);
    } catch (error) {
      console.error('Error al obtener la GetConstruction:', error);
    }
  }

  const getWeekNumber = (creationDate) => {
    const currentDate = new Date(creationDate);
    const januaryFirst = new Date(currentDate.getFullYear(), 0, 1);
    const daysToNextMonday =
      (januaryFirst.getDay() === 1) ? 0 :
        (7 - januaryFirst.getDay()) % 7;
    const nextMonday =
      new Date(currentDate.getFullYear(), 0,
        januaryFirst.getDate() + daysToNextMonday);

    return (currentDate < nextMonday) ? 52 :
      (currentDate > nextMonday ? Math.ceil(
        (currentDate - nextMonday) / (24 * 3600 * 1000) / 7) : 1);
  }

  const getWeekDates = (year, weekNumber) => {

    // Calcula el primer día del año
    const firstDayOfYear = new Date(year, 0, 1);

    // Obtén el día de la semana del primer día del año (0 = domingo, 6 = sábado)
    const dayOfWeek = firstDayOfYear.getDay();

    // Calcula el número de días hasta el primer viernes (ISO 8601 considera lunes como inicio)
    const daysToFirstThursday = (5 - dayOfWeek + 7) % 7;

    // Calcula el primer jueves del año
    const firstThursday = new Date(firstDayOfYear);
    firstThursday.setDate(firstDayOfYear.getDate() + daysToFirstThursday);

    // Avanza a la semana solicitada
    const targetThursday = new Date(firstThursday);
    targetThursday.setDate(firstThursday.getDate() + (weekNumber - 1) * 7);

    return targetThursday;
  }

  // Ejemplo de uso
  // const year = 2025;
  // const weekNumber = 2; // Segunda semana del año
  // const weekDates = getWeekDates(year, weekNumber);

  // console.log(`Fechas de la semana ${weekNumber} del año ${year}:`);
  // weekDates.forEach(date => console.log(date.toLocaleDateString()));


  const fetchRelaciones = async () => {
    try {
      const response = await axios.HTTP_GET(`/api/relaciones/${from.id}`);
      const relacionesConKey = response.map((relacion, index) => ({
        ...relacion,
        key: relacion.id || index, // Usa 'id' si existe, o genera una clave única
      }));
      setRelaciones(relacionesConKey);
    } catch (error) {
      console.error('Error al cargar las relaciones:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // Función para agrupar relaciones por su número de relación
  const agruparPorNumeroRelacion = (relaciones) => {
    if (relaciones !== undefined) {
      return relaciones.reduce((acumulador, relacion) => {
        const numeroRelacion = relacion.numero_relacion;
        if (!acumulador[numeroRelacion]) {
          acumulador[numeroRelacion] = [];
        }
        acumulador[numeroRelacion].push(relacion);
        return acumulador;
      }, {});
    } else return [];
  };

  const agruparRestoDeRelaciones = relaciones => {
    const allRelationships = relacionesCat;

    for (let i = 0; i < allRelationships.length; i++) {
      if (!relaciones[allRelationships[i].value]) relaciones[allRelationships[i].value] = [{ fecha_inicio: null, fecha_fin: null }];
    }

    return relaciones;
  }

  const setRange = (relaciones) => {
    if (relaciones !== undefined) {
      let nextDay = nextDays;

      const allRelationships = relacionesCat;

      for (let i = 0; i < allRelationships.length; i++) {
        if (!relaciones[allRelationships[i].value]) relaciones[allRelationships[i].value] = [{ fecha_inicio: null, fecha_fin: null }];
      }

      let creationDateTmp = new Date(construction.fecha_creacion);
      console.log("creationDateTmp**", creationDateTmp);
      let dateCreationThursday = GetThursdayWeek(creationDateTmp);

      Object.keys(relaciones).map((numeroRelacion, index) => {

        if (relaciones[numeroRelacion] === 1) {
          relaciones[numeroRelacion][0]["fecha_inicio"] = dateCreationThursday.toLocaleDateString('es-MX');
          relaciones[numeroRelacion][0]["fecha_fin"] = addDays(dateCreationThursday, 7).toLocaleDateString('es-MX');
        } else {
          const startDate = AddWeeks({ date: dateCreationThursday, weeks: numeroRelacion });
          relaciones[numeroRelacion][0]["fecha_inicio"] = startDate.toLocaleDateString('es-MX');
          relaciones[numeroRelacion][0]["fecha_fin"] = addDays(startDate, 7).toLocaleDateString('es-MX');
        }


        // if (relaciones[numeroRelacion] === 1) {
        //   relaciones[numeroRelacion][0]["fecha_inicio"] = dateCreationThursday.toLocaleDateString('es-MX');
        //   relaciones[numeroRelacion][0]["fecha_fin"] = addDays(relaciones[numeroRelacion][0]["fecha_inicio"], 6).toLocaleDateString('es-MX');
        // } else {
        //   relaciones[numeroRelacion][0]["fecha_inicio"] = AddWeeks({ date: dateCreationThursday, weeks: numeroRelacion });
        //   relaciones[numeroRelacion][0]["fecha_fin"] = addDays(relaciones[numeroRelacion][0]["fecha_inicio"], 6).toLocaleDateString('es-MX');
        // }

        //if (relaciones[numeroRelacion].length > 0) {
        // relaciones[numeroRelacion][0]["fecha_inicio"] = nextDay.toLocaleDateString();
        // relaciones[numeroRelacion][0]["fecha_fin"] = addDays(nextDay, 6).toLocaleDateString('es-MX');
        // nextDay = addDays(nextDay, 7);
        //}
      })

      return relaciones;
    } else return [];
  }

  const GetThursdayWeek = (date) => {
    const dateTmp = new Date(date);

    while (dateTmp.getDay() !== 4) {
      dateTmp.setDate(dateTmp.getDate() - 1);
    }

    return dateTmp;
  }

  const AddWeeks = params => {
    let { date, weeks } = params;

    const result = new Date(date);
    result.setDate(result.getDate() + weeks * 7);

    return result;
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const calcularSubtotal = (gastos) => {
    return Array.isArray(gastos)
      ? gastos.reduce((subtotal, gasto) => subtotal + parseFloat(gasto.importe || 0), 0).toFixed(2)
      : '0.00';
  };

  const calcularSubtotalConIva = (gastos) => {
    return Array.isArray(gastos)
      ? gastos.reduce((subtotal, gasto) => {
          const importe = parseFloat(gasto.importe || 0);
          const iva = parseFloat(gasto.cpIVA || 0);
          return subtotal + importe + (importe * (iva / 100));
        }, 0).toFixed(2)
      : '0.00';
  };

  const Navigate = (path, params) => {
    navigate(path, params);
  }

  const UpdateRelationship = async (data) => {
    try {
      const editRow = await form.validateFields();
      messageApi.open({ type: 'loading', content: 'Actualizando relación de pago....', duration: 0 });
      const response = await axios.HTTP_POST("/api/v1/relationship/update", { tipo_de_pago: editRow.tipo_de_pago, obraId: from.id, numero_relacion: data.numero_relacion, id: data.id })
      if (response) {
        messageApi.destroy();
        message.success(response.data.msg);
        setEditingKey('');
        fetchRelaciones();
      }

    } catch (e) {
      console.log("err**", e);
    }
  }

  const AuthRelationship = async (data, authLevel) => {
    try {
      messageApi.open({ type: 'loading', content: 'Actualizando relación de pago....', duration: 0 });
      const response = await axios.HTTP_POST("/api/v1/relationship/auth-relationship", { obra_id: from.id, numRelacion: parseInt(data.numero_relacion), levelAuth: authLevel, relacion_id: data.relacion_id })
      if (response) {
        messageApi.destroy();
        message.success(response.data.message);
        fetchRelaciones();
      }

    } catch (e) {
      console.error('Hubo un error al autorizar la relación de pago:', e);
      message.error('Hubo un error al autorizar la relación de pago.');
    }
  }

  {/** FUNCTIONS MODAL VIEW FILES **/ }
  const cancelDialogFiles = () => setDialogFiles(false);
  const openDialogFilesWithParams = (params) => {
    setRelationshipViewer({ numRelation: params.numero_relacion, id: params.partida });
    setDialogFiles(true);
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <Spin size="large" />
        <Typography>Cargando...</Typography>
      </div>
    );
  }

  // Agrupar relaciones por número de relación
  let relacionesAgrupadas = agruparPorNumeroRelacion(relaciones);
  relacionesAgrupadas = setRange(relacionesAgrupadas);
  //relacionesAgrupadas = agruparRestoDeRelaciones(relacionesAgrupadas);
  console.log("relacionesAgrupadas***", relacionesAgrupadas)

  return (
    <div style={{ marginTop: 5 }}>

      <HeaderComponent title={`Relaciones - ${from.nombre_obra}`} />

      {/* <Typography.Title level={5}>Relaciones - {from.nombre_obra}</Typography.Title> */}
      <Divider style={{ margin: '10px 0' }} />

      {Object.keys(relacionesAgrupadas).sort((a, b) => Number(b) - Number(a)).map((numeroRelacion, index) => {
        let relacionesGrupo = relacionesAgrupadas[numeroRelacion];
        //relacionesGrupo = setRange(relacionesGrupo, [numeroRelacion][0]);


        const montosFiscales = relacionesGrupo.filter(gasto => gasto.tipo_monto === 'Fiscal');
        const montosNoFiscales = relacionesGrupo.filter(gasto => gasto.tipo_monto === 'No Fiscal');

        const subtotalFiscales = calcularSubtotalConIva(montosFiscales);
        const subtotalNoFiscales = calcularSubtotal(montosNoFiscales);
        const total = (parseFloat(subtotalFiscales) + parseFloat(subtotalNoFiscales)).toFixed(2);

        // Configuración de las columnas para las tablas
        const columns = [
          {
            title: 'ID',
            dataIndex: 'partida_cp',
            render: (_, payment) => {
              //console.log("partida",payment)
              return (
                <>
                  <a onClick={() => navigate("/payment-control-list", { state: { from: from, contratista_id: payment.contratista_id, cp: payment.control_pago_id } })}> {payment.partida} </a>
                </>
              )
            },
          },
          {
            title: 'Contratista',
            dataIndex: 'nombre_contratista',
            key: 'nombre_contratista',
          },
          {
            title: 'Tipo de Pago',
            dataIndex: 'tipo_de_pago',
            key: 'tipo_de_pago',
            width: '25%',
            editable: true,
          },
          {
            title: 'Rel',
            dataIndex: 'numero_relacion',
            key: 'numero_relacion',
          },
          {
            title: 'Obra',
            render: () => from.nombre_obra,
            key: 'obra',
          },
          {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (fecha_cp) => {
              return (
                <span>{new Date(fecha_cp).toLocaleDateString("es-Mx")}</span>
              )
            },
          },
          {
            title: 'Importe',
            dataIndex: 'importe',
            key: 'importe',
            render: (text) => parseFloat(text).toFixed(2),
          },
          {
            title: "Autorizado",
            dataIndex: "estatus",
            key: "estatus",
            align: 'center',
            render: (_, record) => (
              <>
                {record.estatus === "AUTORIZADO" && <CheckCircleTwoTone twoToneColor="#52c41a" />}
                {(record.estatus === "NO AUTORIZADO" && record.autorizacion_n1 === 0) && <><WarningTwoTone twoToneColor="#faad14" /> <span>(N1)</span></>}
                {(record.estatus === "NO AUTORIZADO" && record.autorizacion_n2 === 0) && <><WarningTwoTone twoToneColor="#faad14" /> <span>(N2)</span></>}
              </>
            )
          },
          {
            title: 'Observaciones',
            dataIndex: 'observaciones',
            key: 'observaciones',
          },
          {
            title: 'Acciones',
            dataIndex: 'operation',
            render: (_, record) => {
              const editable = isEditing(record);
              return editable ? (
                <span>
                  <Typography.Link
                    onClick={() => UpdateRelationship(record)}
                    style={{
                      marginInlineEnd: 8,
                    }}
                  >
                    Guardar
                  </Typography.Link>
                  <Popconfirm title="Seguro de cancelar?" onConfirm={cancel}>
                    <a>Cancelar</a>
                  </Popconfirm>
                </span>
              ) : (
                <>
                  {/* <Button type="default" disabled={editingKey !== ''} onClick={() => edit(record)}>
                    <EditOutlined />
                  </Button>
                  <Typography.Link style={{"marginLeft":"5px"}} onClick={() => openDialogFilesWithParams(record)}>
                    Ver Archivos
                  </Typography.Link> */}
                  {/* <Dropdown 
                    menu={{ items, onClick: ({ key }) => {
                      if (key === '1') openDialogFilesWithParams(record);
                      if (key === '2') edit(record)
                      if (key === '3') authPayment(record);
                    } }}>
                    <a onClick={e => {e.preventDefault(); console.log("record", e)}}>
                      <Space>
                        Ver acciones
                        <DownOutlined />
                      </Space>
                    </a>
                  </Dropdown> */}
                  <DropdownActionsTable
                    record={record}
                    openDialogFilesWithParams={openDialogFilesWithParams}
                    edit={edit}
                    AuthRelationship={AuthRelationship}
                  />
                </>

                // <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                //   Editar
                // </Typography.Link>
              );
            },
          },
        ];

        const EditableCell = ({
          editing,
          dataIndex,
          title,
          inputType,
          record,
          index,
          children,
          ...restProps
        }) => {
          const inputNode = <Select options={catTypes} />;
          return (
            <td {...restProps}>
              {editing ? (
                <Form.Item
                  name={dataIndex}
                  style={{
                    margin: 0,
                  }}
                  rules={[
                    {
                      required: true,
                      message: `Ingresar ${title}!`,
                    },
                  ]}
                >
                  {inputNode}
                </Form.Item>
              ) : (
                children
              )}
            </td>
          );
        };

        const mergedColumns = columns.map((col) => {
          if (!col.editable) {
            return col;
          }
          return {
            ...col,
            onCell: (record) => ({
              record,
              inputType: col.dataIndex === "tipo_de_pago" ? "select" : "text",
              dataIndex: col.dataIndex,
              title: col.title,
              editing: isEditing(record),
            }),
          };
        });

        return (
          <div key={index} style={{ marginBottom: '48px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {/* Primera mini sección */}
              <Typography.Title level={6}>
                Relación: {numeroRelacion} | {relacionesGrupo[0].fecha_inicio} - {relacionesGrupo[0].fecha_fin}
              </Typography.Title>
              {/* {relacionesGrupo[0].estatus !== "AUTORIZADO" && (<div>
                <Button color="cyan" variant='solid' disabled={editingKey !== ''} onClick={() => AuthRelationship({ numeroRelacion })}>
                  Autorizar <SafetyCertificateOutlined />
                </Button>
              </div>)} */}
            </div>


            <Divider style={{ margin: '16px 0' }} />

            {/* Segunda mini sección: Montos Fiscales */}
            {/* <Typography.Text strong>Montos Fiscales</Typography.Text>
            <Form form={form} component={false}>
              <Table
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                dataSource={montosFiscales}
                columns={mergedColumns}
                pagination={false}
                size="small"
                footer={() => (
                  <div style={{ textAlign: 'right' }}>
                    <strong>Subtotal Fiscales:</strong> {subtotalFiscales}
                  </div>
                )}
                rowKey={record => record.id}
              />
            </Form> */}
            <EdicionMontosCmp
              from={from}
              amounts={montosFiscales}
              subtotal={subtotalFiscales}
              typesPayment={catTypes}
              amountLabel="Montos Fiscales"
              refreshData={fetchRelaciones}
              openDialogFilesWithParams={openDialogFilesWithParams}
            />

            {/* Tercera mini sección: Montos No Fiscales */}
            {/* <Typography.Text strong style={{ marginTop: '16px', display: 'block' }}>Montos No Fiscales</Typography.Text> */}
            {/* <Form form={form} component={false}>
              <Table
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                dataSource={montosNoFiscales}
                columns={mergedColumns}
                pagination={false}
                size="small"
                footer={() => (
                  <div style={{ textAlign: 'right' }}>
                    <strong>Subtotal No Fiscales:</strong> {subtotalNoFiscales}
                  </div>
                )}
                rowKey={record => record.id}
              />
            </Form> */}

            <EdicionMontosCmp
              from={from}
              amounts={montosNoFiscales}
              subtotal={subtotalNoFiscales}
              typesPayment={catTypes}
              amountLabel="Montos No Fiscales"
              refreshData={fetchRelaciones}
              openDialogFilesWithParams={openDialogFilesWithParams}
            />

            {/* Cuarta mini sección: Total de los subtotales */}
            <Typography.Title level={6} style={{ marginTop: '16px' }}>Total: ${numberFormat.format(total)}</Typography.Title>
          </div>
        );
      })}

      {/* Botón de regresar */}
      {/* <div style={{ textAlign: 'center' }}>
        <Button type="default" onClick={() => Navigate("/home", { state: { from: from } } )}>
          Regresar
        </Button>
      </div> */}

      {/** INIT MODAL VIEW FILES **/}
      <ModalVisualizacionArchivos
        relationship={relationshipViewer}
        openDialogFiles={openDialogFiles}
        cancelDialogFiles={cancelDialogFiles}
      />
      {/** END MODAL VIEW FILES **/}

    </div>
  );
}

export default Relaciones;
